document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.icons').forEach((element) => {
    const holder = element.querySelector('.icons-holder');
    const scrollIndicator = element.querySelector('.icons-scroll-indicator');
    const itemsCount = holder.querySelectorAll('.icons-element').length;
    const gapWidth = parseInt(window.getComputedStyle(holder).getPropertyValue('column-gap')) || 0;
    const leftMargin = parseInt(
      window.getComputedStyle(holder.querySelector('.icons-element:first-child')).getPropertyValue('margin-left')
    );
    const rightMargin = parseInt(
      window.getComputedStyle(holder.querySelector('.icons-element:last-child')).getPropertyValue('margin-right')
    );
    const innerWidth =
      itemsCount * holder.querySelector('.icons-element').offsetWidth +
      (itemsCount - 1) * gapWidth +
      leftMargin +
      rightMargin;
    scrollIndicator.style.setProperty('--outerWidth', holder.offsetWidth);
    scrollIndicator.style.setProperty('--innerWidth', innerWidth);
    holder.addEventListener('scroll', () => scrollIndicator.style.setProperty('--amountScrolled', holder.scrollLeft));
    if (innerWidth > holder.offsetWidth) {
      scrollIndicator.classList.remove('opacity-0');
    }
  });
});
